const API_KEY = "53703295-e75262fb494aab51a48093056";
const BASE_URL = 'https://pixabay.com/api/';

export const fetchImages = async (query, page) => {
  const response = await fetch(
    `${BASE_URL}?q=${query}&page=${page}&key=${API_KEY}&image_type=photo&orientation=horizontal&per_page=12`
  );

  if (!response.ok) {
    throw new Error('Error fetching images');
  }

  const data = await response.json();
  return data.hits;
};
